class UsuarioCadastro{
    constructor(){
        this.idConta = null;
        this.idAmbiente = null;
        this.idContribuinte = null;
        this.idUsuarioPrincipal = null;
        this.idUsuario = null;
        this.idPessoa = null;
        this.documento = null;
        this.nome = null;
        this.email = null;
        this.solicitarEmail = true; 
        this.login = null;
        this.senha = null;
    }
}
export default UsuarioCadastro;